import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35553178"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }

import { ref, toRefs } from 'vue';

  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'simple-button',
  props: {
    content: String,
    inverted: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    linkTarget: {
      type: String,
      default: null,
    },
    linkMethod: {
      type: String,
      default: null,
    },
    submitForm: {
      type: Boolean,
      default: false,
    },
    useTheming: {
      type: Boolean,
      default: false,
    },
    useIncognitoTheming: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["main-action"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  const { inverted, filled, linkTarget, linkMethod, submitForm, useTheming, useIncognitoTheming } = toRefs(props);
  const root = ref<HTMLElement | null>(null);

  const buttonClick = () => {
      if (submitForm.value) {
        const form =  root.value?.closest('form');
        if(form) form.submit();
      } else {
        if (
          linkTarget.value &&
          (!linkMethod.value || linkMethod.value.toLowerCase() === "get")
        ) {
          window.location.href = linkTarget.value;
        } else if (linkTarget.value && linkMethod.value && linkMethod.value) {
          // Get CSRF-Token
          const metas = document.getElementsByTagName("meta");
          let token = null;
          for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute("name") === "csrf-token") {
              token = metas[i].getAttribute("content");
              break;
            }
          }

          // Create an setup form
          const form = document.createElement("form");
          form.action = linkTarget.value;
          form.method = "post";
          form.style.display = "none";

          // Smuggle in the method (because forms only can post)
          // so that rails understands we are doing a emulated "this.linkMethod"-call
          let input = document.createElement("input");
          input.type = "hidden";
          input.name = "_method";
          input.value = linkMethod.value.toLowerCase();
          form.appendChild(input);

          // Append authenticity token for CSRF protection
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "authenticity_token";
          if(token)
          input.value = token;
          form.appendChild(input);

          // Apend and send form
          document.body.appendChild(form);
          form.submit();
        } else {
          emit("main-action");
        }
      }
    };
    const cssClasses = () => {
      const result = [];

      // { inverted, filled, unthemed: !useTheming }

      if (inverted.value) {
        result.push("inverted");
      } else if (filled.value) {
        result.push("filled");
      }

      if (useTheming.value) {
        if (inverted.value) {
          result.push(themingCssClass("hover_main_color"));
        } else if (filled.value) {
          result.push(themingCssClass("border"));
          result.push(themingCssClass("inverted"));
          result.push(themingCssClass("hover_box"));
        } else {
          result.push(themingCssClass("border"));
          result.push(themingCssClass("normal"));
          result.push(themingCssClass("hover_invert"));
        }
      } else if(!useIncognitoTheming.value) {
        result.push("theming-not-used");
      }

      return result;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    onClick: buttonClick,
    class: _normalizeClass(["components__simple-button center", cssClasses()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})